import { PropsWithChildren } from "react";
import { Avatar, Flex, Text } from "@radix-ui/themes";

interface StepProps {
  index: number;
  label: string;
  description?: string;
}

export function Step({
  index,
  label,
  description,
  children,
}: PropsWithChildren<StepProps>) {
  return (
    <Flex gap={"2"}>
      <Flex width={"400px"} flexShrink={"0"} gap={"4"}>
        <Avatar size="2" radius="full" fallback={index.toString()} />

        <Flex pt={"3px"} direction={"column"} gap={"1"} align={"start"}>
          <Text size={"4"} color={"gray"} weight={"medium"} highContrast>
            {label}
          </Text>

          {description && (
            <Text size={"3"} color={"gray"}>
              {description}
            </Text>
          )}
        </Flex>
      </Flex>

      <Flex flexGrow={"1"}>{children}</Flex>
    </Flex>
  );
}
